import { Box, Icon } from "@outschool/backpack";
import { faChevronRight } from "@outschool/icons";
import { Loading } from "@outschool/ui-legacy-component-library";
import React from "react";

import CardClassList from "./CardClassList";
import CardHeading from "./CardHeading";
import CardLink from "./CardLink";

interface ListCardProps {
  id: string;
  url: string;
  loading: boolean;
  listings: any[];
  trackingProperties: any;
  title: string;
  subtitle?: string;
  filter?: React.ReactNode;
}

/** Parent dashboard card that displays a list of classes */
export default function ListCard({
  id,
  title,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  subtitle = null,
  url,
  loading,
  listings,
  trackingProperties,
  filter
}: ListCardProps) {
  const showOutline = true;
  return loading || listings?.length ? (
    <Box
      flex
      sx={{
        flexDirection: "column",
        color: "grey.900",
        boxShadow: showOutline ? "0 2px 10px rgba(0, 0, 0, 0.25)" : null,
        borderRadius: showOutline ? "1em" : null,
        marginY: showOutline ? "1em" : null,
        marginLeft: showOutline ? null : "-24px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderBottom: showOutline ? "1px solid" : null,
          borderColor: showOutline ? "grey.100" : null,
          overflowX: showOutline ? "hidden" : null
        }}
      >
        <CardLink
          url={url}
          id={id}
          trackingProperties={{ ...trackingProperties, cardLocation: "header" }}
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          {/* @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message */}
          <CardHeading title={title} subtitle={subtitle} />
          <Icon
            icon={faChevronRight}
            sx={{
              marginRight: showOutline ? "1em" : null
            }}
          />
        </CardLink>
        {filter}
      </Box>
      <Box
        sx={{
          padding: "16px",
          overflow: showOutline ? "hidden" : null,
          paddingTop: showOutline ? undefined : 0
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <CardClassList
            listings={listings}
            id={id}
            url={url}
            trackingProperties={trackingProperties}
          />
        )}
      </Box>
    </Box>
  ) : null;
}
